import { ChoroplethMapData } from '../models/plots/choropleth-map-data.model';
import { ChoroplethMapInput } from '../models/plots/choropleth-map-input.model';
import { PlotlyPlot } from '../models/plots/plotly-plot.model';
import { CHOROPLETH_MAP_COLORS } from './plotly-colors';

export class ChoroplethMapPlotly {
  static create(input: ChoroplethMapInput): PlotlyPlot<ChoroplethMapData> {
    const data: ChoroplethMapData = {
      type: 'choropleth',
      locations: input.countryCodes,
      z: input.locationValues,
      locationmode: 'ISO-3',
      text: input.locationDisplayNames,
      showscale: true,
      colorbar: {
        title: {
          text: 'Incidents',
          font: {
            size: 14,
            family: 'MunichRE',
            color: '#1c1b1b',
            weight: 500,
          },
        },
        outlinewidth: 0,
        tickfont: {
          size: 14,
          family: 'MunichRE',
          color: '#1c1b1b',
          weight: 400,
        },
        tickprefix: '  ', // The only way to add space between the colorbar and the values displayed on the right of it
      },
      colorscale: CHOROPLETH_MAP_COLORS,
    };

    return {
      data: [data],
      layout: {
        geo: {
          projection: {
            type: 'equirectangular',
          },
          ...(input.continentScope ? { scope: input.continentScope } : {}),
          framewidth: 0,
        },
        margin: {
          t: 10,
          b: 10,
        },
      },
      config: {
        scrollZoom: false,
        doubleClick: false,
        displayModeBar: false,
        showLink: false,
      },
    };
  }
}
